/*
 * Copyright (C) 2015 Spanning Cloud Apps LLC.  All rights reserved.
 */
import './bulkRestoreDetails.tpl.html';
import './bulkRestoreDetailsRow.tpl.html';

/**
 * Module for the bulkRestoreDetails.
 */
angular
  .module('batch.bulkRestore.details', [])
  .constant('BATCH_ACTION_ENUM', {
    1: 'INSERTED',
    2: 'UNDELETED',
    3: 'UPDATED'
  })
  /**
   * Controller for the BulkRestoreDetails template.
   */
  .controller(
    'BulkRestoreDetailsCtrl',
    function (
      $scope,
      $filter,
      $timeout,
      $rootScope,
      BulkRestoreService,
      batchUtils,
      pagingUtils,
      batchErrors,
      BATCH_RESULTS,
      BATCH_ACTION_ENUM,
      BULK_RESTORE_BATCH_RESULT_TABS,
      NON_RESTORABLE_EVENT_CODE
    ) {
      var tempFilterText,
        filterTextTimeout,
        nonRestorableRecordsPage = 0;

      $scope.batchErrors = batchErrors;
      $scope.successfulRestoredRecords = [];
      $scope.nonRestorableRecordsRecords = [];
      $scope.initialLoad = true;
      $scope.resultTabs = BULK_RESTORE_BATCH_RESULT_TABS;
      $scope.instanceUrl = $rootScope.instanceUrl;
      $scope.overwriteMap =
        $scope.batchUtils.currentBatch.bulkRestoreData && $scope.batchUtils.currentBatch.bulkRestoreData.overwriteMap;
      $scope.specificFieldMap =
        $scope.batchUtils.currentBatch.bulkRestoreData && $scope.batchUtils.currentBatch.bulkRestoreData.specificFields;
      $scope.specificFields = _.map($scope.specificFieldMap, function (fieldList, objectType) {
        return { objectType: objectType, fieldNames: fieldList.join(',') };
      });
      $scope.NON_RESTORABLE_EVENT_CODE = NON_RESTORABLE_EVENT_CODE;
      // object used to track the difference properties that drive the table.
      $scope.headerValues = {
        name: 'sfName',
        id: 'id',
        type: 'type',
        result: 'result'
      };
      // property used to order the data in the table.  It must match one of the keys from the headerValues obj.
      $scope.predicate = $scope.headerValues.name;
      // direction of the data.
      $scope.pagingParam = pagingUtils.pagingInfo.bulkRestoreDetails;
      $scope.reverse = $scope.pagingParam.ascending;

      // Paging stuff
      $scope.pagingParam.currentPage = 1;

      /**
       * Utility to retrieve the records with the current parameters and update
       * the data on the page.
       */
      $scope.updateRecords = function () {
        var query = '';
        $scope.pagingParam = pagingUtils.pagingInfo.bulkRestoreDetails;
        if ($scope.$parent) {
          $scope.$parent.showDetailsMask = true;
          query = $scope.$parent.bulkRestoreQuery;
        }
        var params = {
          batchId: $scope.batchUtils.currentBatch.batchId,
          page: $scope.pagingParam.currentPage - 1,
          pageSize: $scope.pagingParam.itemsPerPage,
          filter: query,
          sort: $scope.pagingParam.sortBy,
          ascending: $scope.pagingParam.ascending
        };

        BulkRestoreService.getBatchDetails(params).then(function (results) {
          $scope.pagingParam.totalPages = Math.ceil(results.count / $scope.pagingParam.itemsPerPage);
          $scope.pagingParam.totalItems = results.count;
          pagingUtils.pagingInfo.bulkRestoreDetails = $scope.pagingParam;
          $scope.successfulRestoredRecords = results.rows;
          $scope.initialLoad = false;
          if ($scope.$parent) {
            $scope.$parent.showDetailsMask = false;
          }
        });
      };

      $scope.updateRecords();

      /**
       * Function used to get next 10 nonRestorable records for batch.
       */
      $scope.getNextNonRestorableRecords = function () {
        batchUtils
          .getBatchEvents(batchUtils.currentBatch.batchId, NON_RESTORABLE_EVENT_CODE, nonRestorableRecordsPage)
          .then(function (records) {
            $scope.nonRestorableRecordsRecords = $scope.nonRestorableRecordsRecords.concat(records);
            nonRestorableRecordsPage++;
          });
      };

      if (batchErrors[NON_RESTORABLE_EVENT_CODE]) {
        $scope.getNextNonRestorableRecords();
        $scope.nonRestorableRecordsRecordsCount = batchErrors[NON_RESTORABLE_EVENT_CODE];
      }

      // Detect changes in the records filter and trigger a delay before
      // performing an update to the records.
      $scope.$watch(
        function () {
          return $scope.$parent.bulkRestoreQuery;
        },
        function (val) {
          if (filterTextTimeout) {
            $timeout.cancel(filterTextTimeout);
          }
          tempFilterText = val;
          $scope.setQuery(tempFilterText);
          filterTextTimeout = $timeout(function () {
            $scope.setQuery(tempFilterText);
            if (!$scope.initialLoad) {
              $scope.updateRecords();
            }
          }, 600); // delay 600 ms
        }
      );

      $scope.$watch(
        function () {
          return $scope.pagingParam.currentPage;
        },
        function () {
          if (!$scope.initialLoad) {
            $scope.updateRecords();
          }
        }
      );

      /**
       * Utility to update the query in the parent scope.
       *
       * @param {string} query - The query value to update.
       */
      $scope.setQuery = function (query) {
        if ($scope.$parent) {
          $scope.$parent.bulkRestoreQuery = query;
        }
      };

      /**
       * Sets the sort parameter to the header selected.
       *
       * @param {string} header - The header value and property to sort by.
       */
      $scope.selectHeader = function (header) {
        $scope.reverse = !$scope.reverse;
        $scope.pagingParam.sortBy = header;
        $scope.pagingParam.ascending = $scope.reverse;
        pagingUtils.updateBulkRestoreDetails($scope.pagingParam);
        // Update the records;
        if (!$scope.initialLoad) {
          $scope.updateRecords();
        }
      };

      /**
       * Returns boolean whether to show up or down arrow for header.
       *
       * @param {string} header - The header value.
       * @returns {string} - The class to use.
       */
      $scope.isSelectedHeader = function (header) {
        var headerClass = '';
        if ($scope.pagingParam.sortBy === header) {
          if (!$scope.reverse) {
            headerClass = 'sbsf-log-header-desc sca-icon-down-black';
          } else {
            headerClass = 'sbsf-log-header-asc sca-icon-down-black';
          }
        }
        return headerClass;
      };

      /**
       * Returns boolean whether or not batch is a Cross Org Restore.
       *
       * @returns {boolean} - if batch is cross org restore or not.
       */
      $scope.isCrossOrgRestore = function () {
        return $scope.batchUtils.currentBatch && $scope.batchUtils.currentBatch.type === 'CROSS_ORG_RESTORE';
      };

      /**
       * Returns the action text for the record.
       *
       * @param {object} record - The record object.
       *
       * @return {string} - The action text.
       */
      $scope.getAction = function (record) {
        return BATCH_ACTION_ENUM[record.action] ? $filter('i18n')(BATCH_ACTION_ENUM[record.action]) : '';
      };
    }
  )
  .controller(
    'BulkRestoreDetailsRowCtrl',
    function ($scope, $filter, $rootScope, batchUtils, ERROR_TYPES, BULK_RESTORE_EVENTS) {
      var nextPageNum = 0;
      $scope.showMessages = false;
      $scope.erroredRecords = [];

      $scope.errorType = ERROR_TYPES[$scope.code].type ? $filter('i18n')(ERROR_TYPES[$scope.code].type) : '';
      $scope.description = ERROR_TYPES[$scope.code].description
        ? $filter('i18n')(ERROR_TYPES[$scope.code].description)
        : '';

      $rootScope.$on(BULK_RESTORE_EVENTS.COLLAPSE_ALL, function () {
        $scope.showMessages = false;
      });

      /**
       * Returns boolean whether to show up or down arrow for error message container.
       * @returns {string} - The class to use.
       */
      $scope.isExpanded = function () {
        var headerClass = '';
        if (!$scope.showMessages) {
          headerClass = 'sbsf-log-header-asc sca-icon-down-black';
        } else {
          headerClass = 'sbsf-log-header-desc sca-icon-down-black';
        }
        return headerClass;
      };

      /**
       * Function used to get next 10 errored records for batch.
       */
      $scope.getNextRecords = function () {
        batchUtils.getBatchEvents(batchUtils.currentBatch.batchId, $scope.code, nextPageNum).then(function (records) {
          $scope.erroredRecords = $scope.erroredRecords.concat(records);
          nextPageNum++;
        });
      };

      /**
       * Function used to hide the error message container.
       */
      $scope.hideMessage = function () {
        $scope.showMessages = !$scope.showMessages;

        // lazy load the records
        if ($scope.showMessages && $scope.erroredRecords.length === 0) {
          batchUtils.getBatchEvents(batchUtils.currentBatch.batchId, $scope.code).then(function (records) {
            $scope.erroredRecords = records;
            nextPageNum++;
          });
        }
      };
    }
  )
  /**
   * The directive for the bulkrestore details row. The record is the record object of the row.
   */
  .directive('bulkRestoreDetailsRow', function () {
    return {
      templateUrl: 'batch/bulkRestore/details/bulkRestoreDetailsRow.tpl.html',
      scope: {
        code: '=',
        count: '='
      },
      controller: 'BulkRestoreDetailsRowCtrl'
    };
  });
